import { fromNode } from '@rehaje/core'
import { reactive, untrack } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

import type { SchemaModel, SchemaNode } from '../../models'
import type { SchemaReferenceNode } from './TypedNode'
import type { TypedNode, TypedSpecific } from '@rehaje/core'

export class SchemaReferenceModel extends ValuableModel {
  @fromNode()
  @reactive()
  ref?: string

  @reactive('computed')
  get refNode(): TypedNode | undefined {
    const ref = this.ref
    return untrack(() => {
      const selfNode = this.getTypedNode<SchemaReferenceNode>()
      const node = this.store.node.find<SchemaNode>(ref)
      if (node) {
        return selfNode.spawn<TypedNode>(['current'], {
          ...node.schema,
          name: this.name
        } as TypedSpecific)
      }
    })
  }

  override joinChildNamePath(child: SchemaModel) {
    return [...this.namePath, ...child.names]
  }

  override joinChildrenValuePath(child: SchemaModel) {
    if (this.parent) {
      return [...this.parent.valuePath, ...child.names]
    }
    return child.names
  }

  /**
   * 渲染节点
   */
  override render() {
    if (this.value !== undefined) {
      return super.render(this.refNode?.render())
    }
  }
}

declare global {
  export interface RehajeViewModels {
    'Schema.Reference': SchemaReferenceModel
  }
}
